/**
 * Source unique des réalisations.
 *
 * Consommée par : la page d'accueil (carrousel), la page Portfolio (grille
 * filtrable) et les pages de service (section « Nos Réalisations »).
 * Ajouter un projet ici suffit à le faire apparaître partout où il est pertinent.
 *
 * Champs :
 *  - category    : catégorie utilisée par le filtre du portfolio
 *  - badge       : libellé affiché sur le carrousel d'accueil (défaut : category)
 *  - summary     : phrase courte (accueil + cartes des pages de service)
 *  - description : phrase longue (page Portfolio)
 *  - services    : slugs des pages de service où le projet doit apparaître
 *  - featured    : présence dans le carrousel de la page d'accueil
 *  - link        : absent = « Cas d'étude privé »
 */

export const CATEGORIES = ["Tous", "Web", "Mobile", "SaaS", "Logiciel & Système"];

export const projects = [
  {
    title: "SalonHub",
    category: "SaaS",
    summary: "Plateforme de réservation pour salons de coiffure",
    description:
      "Plateforme de réservation complète pour les salons de coiffure et instituts de beauté.",
    image: "/images/dev-web/1.png",
    link: "https://salonhub.flowkraftagency.com",
    tags: ["React", "Node.js", "Firebase"],
    services: ["developpement-web"],
    featured: true,
  },
  {
    title: "Perform-Co",
    category: "Web",
    badge: "Site Web",
    summary: "Plateforme d'accompagnement à la performance",
    description:
      "Site vitrine moderne pour une plateforme d'accompagnement à la performance.",
    image: "/images/portfolio/perform-co.png",
    link: "https://perform-co.com/",
    tags: ["React", "Tailwind CSS", "Framer Motion"],
    services: ["developpement-web"],
    featured: true,
  },
  {
    title: "Mystik Legend's Drinks",
    category: "Web",
    badge: "Site Web",
    summary: "Gestion des commandes et des clients",
    description:
      "Application web pour la gestion des commandes et des clients.",
    image: "/images/portfolio/mystik.png",
    link: "https://mystikdrinks.com",
    tags: ["Next.js", "Tailwind CSS", "PWA"],
    services: ["developpement-web"],
  },
  {
    title: "OmniBat",
    category: "Web",
    badge: "Site Web",
    summary: "Solution de gestion pour le bâtiment",
    description:
      "Solution digitale pour la gestion des entreprises du bâtiment.",
    image: "/images/portfolio/omnibat.png",
    link: "https://omnibat.pro/",
    tags: ["React", "Design System"],
    services: ["developpement-web"],
    featured: true,
  },
  {
    title: "Muno",
    category: "Logiciel & Système",
    summary: "Plateforme de gestion municipale",
    description:
      "Plateforme de gestion municipale unifiée : signalements géolocalisés, priorisation algorithmique et suivi des interventions terrain.",
    image: "/images/portfolio/muno.png",
    link: "https://muno.flowkraftagency.com/",
    tags: ["SaaS", "Cartographie", "Temps réel"],
    services: ["solutions-metier"],
  },
  {
    title: "H360",
    category: "Logiciel & Système",
    summary: "Solution intelligente de gestion hospitalière",
    description:
      "Solution intelligente de gestion hospitalière centralisant le suivi des patients, des services et de l'activité de l'établissement.",
    image: "/images/portfolio/h360.png",
    tags: ["Santé", "Système d'information"],
    services: ["solutions-metier"],
  },
  {
    title: "Fluxa360",
    category: "Logiciel & Système",
    summary: "Multi-gestion de points de vente",
    description:
      "Solution de multi-gestion de points de vente : stocks, encaissements et pilotage de la performance commerciale sur l'ensemble du réseau.",
    image: "/images/portfolio/fluxa360.png",
    tags: ["Retail", "Multi-sites", "Reporting"],
    services: ["solutions-metier"],
  },
  {
    title: "TeamShuffle",
    category: "Mobile",
    badge: "Mobile App",
    summary: "Organisation de tournois sportifs",
    description:
      "Application mobile permettant d'organiser des tournois et de créer des équipes équilibrées.",
    image: "/images/dev-mobile/miniature.jpeg",
    link: "https://teamshuffle.flowkraftagency.com",
    tags: ["React Native", "Algorithm"],
    services: ["developpement-mobile"],
    featured: true,
  },
  {
    title: "Budgera",
    category: "Mobile",
    badge: "Mobile App",
    summary: "Gestion de budget personnel, hors ligne",
    description:
      "Application de gestion de budget personnel : suivi des dépenses au quotidien, sans compte et entièrement hors ligne.",
    image: "/images/portfolio/budgera.png",
    link: "https://budgera.flowkraftagency.com/",
    tags: ["iOS", "Android", "Offline-first"],
    services: ["developpement-mobile"],
  },
  {
    title: "KoppaFoot",
    category: "Mobile",
    badge: "Mobile App",
    summary: "Suivi de matchs de football en direct",
    description:
      "Suivi de matchs de football en direct : scores, calendriers et résultats des compétitions africaines.",
    image: "/images/portfolio/koppafoot.png",
    link: "https://koppafoot.com",
    tags: ["Live Score", "Sport", "Temps réel"],
    services: ["developpement-mobile"],
  },
  {
    title: "Contrôle Routier",
    category: "Mobile",
    badge: "Mobile App",
    summary: "Gestion et suivi des contrôles routiers",
    description:
      "Application métier pour la gestion et le suivi des contrôles routiers.",
    image: "/images/dev-mobile/654133.png",
    tags: ["Mobile App", "Business Logic"],
    services: ["developpement-mobile"],
  },
  {
    title: "GCSGC Agency",
    category: "Web",
    badge: "Site Web",
    summary: "Refonte de l'identité numérique et du site web",
    description:
      "Refonte complète de l'identité numérique et du site web de l'agence.",
    image: "/images/dev-web/354484.png",
    tags: ["UI/UX", "Performance"],
    services: ["developpement-web", "design-ux-ui"],
  },
  {
    title: "Portfolio Flora",
    category: "Web",
    badge: "Site Web",
    summary: "Portfolio artistique sur mesure",
    description:
      "Portfolio artistique sur mesure mettant en avant des créations visuelles.",
    image: "/images/dev-web/flor.png",
    tags: ["Creative Design", "React"],
    services: ["developpement-web", "design-ux-ui"],
  },
];

/** Projets mis en avant sur la page d'accueil. */
export const featuredProjects = projects.filter((p) => p.featured);

/** Projets rattachés à une page de service, identifiée par son slug. */
export const getProjectsByService = (slug) =>
  projects.filter((p) => p.services.includes(slug));

/** Projets d'une catégorie du portfolio ("Tous" renvoie l'ensemble). */
export const getProjectsByCategory = (category) =>
  category === "Tous" ? projects : projects.filter((p) => p.category === category);
